import * as Sentry from '@sentry/browser';

import type {Severity} from '@sentry/browser';
import type {SentryEvent} from 'src/internal/errors/sentry/types';

export function sanitizeExtras(data: any): any {
  if (data) {
    try {
      return JSON.parse(JSON.stringify(data));
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e: any) {
      return {
        // If you see this in a sentry, it means you attempted to pass it data that caused an exception
        // when attempting serialization (like a circular reference).
        // Instead of failing to send the sentry entirely, we'll still let it through but with the
        // non-serializable extra stripped and replaced with this.
        bad_extra: 'Extra data could not be serialized',
      };
    }
  }

  return data;
}

export function extractErrorMessage(event: SentryEvent): string | undefined {
  const exceptionValues = event?.exception?.values;

  if (Array.isArray(exceptionValues) && exceptionValues.length >= 1) {
    return String(exceptionValues[0].value);
  }
}

export function normalizeErrorLevel(
  severity: Severity | string | undefined,
): 'error' | 'warning' | 'info' {
  const levelMap = {
    [Sentry.Severity.Fatal]: 'error',
    [Sentry.Severity.Critical]: 'error',
    [Sentry.Severity.Error]: 'error',
    [Sentry.Severity.Warning]: 'warning',
    [Sentry.Severity.Log]: 'info',
    [Sentry.Severity.Info]: 'info',
    [Sentry.Severity.Debug]: 'info',
  } as const;

  return severity ? levelMap[severity as Sentry.Severity] : 'error';
}
